import * as React from 'react';
import { SVGProps } from 'react';

const IconFlagFilledSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M13 2H3v12h2v-4h8l-1.667-4L13 2z" />
  </svg>
);
export default IconFlagFilledSizeS;
